import { PageController } from '@client/components/_core/layout/PageController';
import { useUser } from '@client/hooks/business/user/useUser';
import { useNavigate } from '@client/hooks/navigation/useNavigate';
import { hasPermission } from '@shared/permissions/roles';
import { createFileRoute, Navigate } from '@tanstack/react-router';
import { CreateTokenDrawer } from './components/CreateTokenDrawer';
import { useShowTokenSecret } from './components/token-secret-context';

export const Route = createFileRoute('/console/$orgId/configuration/api-integrations/api-tokens/create')({
    staticData: {
        presentation: 'overlay',
        metadata: {
            title: 'Create API token',
        },
    },
    component: RouteComponent,
});

function RouteComponent() {
    const { orgId } = Route.useParams();
    const user = useUser();
    const navigate = useNavigate();
    const showTokenSecret = useShowTokenSecret();
    const canCreate = hasPermission(user.roles, 'service_api_token:create') && !user.isSupportAccount;

    if (!canCreate) {
        return <Navigate to="/console/$orgId/configuration/api-integrations/api-tokens" params={{ orgId }} replace />;
    }

    return (
        <PageController route={Route}>
            <CreateTokenDrawer
                onClose={() => {
                    navigate({ moveInMatches: -1 });
                }}
                onSuccess={(token, name, expiresAt) => {
                    showTokenSecret({ token, name, expiresAt });
                }}
            />
        </PageController>
    );
}
